import { FC, useMemo } from 'react';
import { Heading } from '@qga/roo-ui/components';

import { InfoModal } from 'components/Layout';
import { sanitizeHTML } from 'lib/utils';
import { BreakOnNewLine } from 'components/Typography';

interface CancellationPolicyModalProps {
  [key: string]: any;
  rawDescription: string;
}

const CancellationPolicyModal: FC<CancellationPolicyModalProps> = ({ rawDescription, ...modalProps }) => {
  const description = useMemo(() => sanitizeHTML(rawDescription), [rawDescription]);

  return (
    <InfoModal title="Cancellation Policy" {...modalProps}>
      <InfoModal.body p="5" pb="10">
        <Heading.h4>Description</Heading.h4>
        <BreakOnNewLine dangerouslySetInnerHTML={{ __html: description }} />
      </InfoModal.body>
    </InfoModal>
  );
};

export default CancellationPolicyModal;
